import React, { useState, useEffect, useRef } from "react";
import { Clock, ArrowRight, CheckCircle, X, Calendar, Info } from "lucide-react";
import { format } from "date-fns";
import Moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';
import { fetchPassengerDetails, selectPassengerDetails, selectPassengerDetailsStatus, UpdatePassengers } from "./flightSlice";
import { selectCurrentUser } from "../auth/authSlice";
import ItineraryLoader from "../../components/ItineraryLoader";
import { DateInput } from "@mantine/dates";
import { Dialog } from "@headlessui/react";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import CurFt from "../../components/CurFt";

function getDobRange(paxType, travelDate) {
  let minDate, maxDate;

  switch (paxType) {
    case "ADULT":
      // Adult = > 12 years, up to 100 years
      maxDate = new Date(travelDate.getFullYear() - 12, travelDate.getMonth(), travelDate.getDate());
      minDate = new Date(travelDate.getFullYear() - 100, travelDate.getMonth(), travelDate.getDate());
      break;

    case "CHILD":
      // Child = between 2 and 12 years
      maxDate = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());
      minDate = new Date(travelDate.getFullYear() - 12, travelDate.getMonth(), travelDate.getDate());
      break;

    case "INFANT":
      // Infant = < 2 years
      maxDate = travelDate; // Not later than travel date
      minDate = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());
      break;

    default:
      // fallback = allow up to 100 years old
      maxDate = travelDate;
      minDate = new Date(travelDate.getFullYear() - 100, travelDate.getMonth(), travelDate.getDate());
  }

  return { minDate, maxDate };
}

function getPassportIssueRange() {
  const today = new Date();
  const minDate = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate()); // 10 years back
  const maxDate = today; // cannot be in future
  return { minDate, maxDate };
}

function getPassportExpiryRange(travelDate) {
  // min = travel date + 6 months
  const minDate = new Date(travelDate);
  minDate.setMonth(minDate.getMonth() + 6);

  // max = travel date + 20 years
  const maxDate = new Date(
    travelDate.getFullYear() + 20,
    travelDate.getMonth(),
    travelDate.getDate()
  );

  return { minDate, maxDate };
}

export default function UpdatePassenger() {
  useDocumentTitle('Update Passenger');
  const { BookingID } = useParams()
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const PassengerDetails = useSelector(selectPassengerDetails);
  const PassengerDetailsStatus = useSelector(selectPassengerDetailsStatus);
  const user = useSelector(selectCurrentUser)
  const [CurrentStatus, SetCurrentStatus] = useState('');

  const [BookingData, setBookingData] = useState([]);
  const [TravelDate, setTravelDate] = useState(new Date());

  const inputRef = useRef();

  const [nationality, setnationality] = useState('');
  const [CustomerMember, setCustomerMember] = useState([]);
  const [CustomerMem, setCustomerMem] = useState([]);
  const [CustomerMemberload, setCustomerMemberload] = useState(0);
  const [memberDetails, setMemberDetails] = useState([])
  const SearchMember = (e, index, PaxType) => {
    let keyword = e.target.value
    const filteredData = CustomerMember.filter(
      (item) => item.PaxType == PaxType && (item.fname.toLowerCase().includes(keyword.toLowerCase()) || item.lname.toLowerCase().includes(keyword.toLowerCase()))
    );
    setCustomerMem(filteredData);
    setCustomerMemberload(index + 1)
  }
  const formatDateToYMD = (dateStr) => {
    if (!dateStr) return '';

    // expected format: DD/MM/YYYY
    const [day, month, year] = dateStr.split('/');

    if (!day || !month || !year) return '';

    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };
  const handleMemberSelect = (event, index) => {
    console.log(event);

    setMemberDetails(prev => {
      const data = [...prev];

      data[index] = {
        ...data[index], // clone object
        fname: event.fname?.toUpperCase() || '',
        lname: event.lname?.toUpperCase() || '',
        title: event.title?.toUpperCase() || '',
        passno: event.passno?.toUpperCase() || '',
        passisse: formatDateToYMD(event.passisse) || null,
        passexp: formatDateToYMD(event.passexp) || null,
        dob: formatDateToYMD(event.dateofbirth) || null,
        passnational: event.passnational?.toUpperCase() || '',
      };

      return data;
    });
  };

  const [currency, setCurrency] = useState({
    CurrencyRate: "1",
    CurrencyTitle: "INR",
    CurrencyId: 1,
  }); // 15 min session

  let IsApiBooking = true;
  useEffect(() => {
    if (BookingID && currency) {
      // dispatch(fetchBookingDetails({ BookingID, currency }));
      dispatch(fetchPassengerDetails({ BookingID, IsApiBooking }));
    }
  }, [BookingID, dispatch]);

  const validationData = PassengerDetails || {};
  const validationStatus = PassengerDetailsStatus || "idle";

  const isLoading = validationStatus === "loading";
  useEffect(() => {
    if (validationStatus === "succeeded" && validationData) {
      console.log(validationData);

      const data = validationData.data
      if (validationData.status.success) {
        setBookingData(validationData.FlightBookig)
        setMemberDetails(validationData?.memberDetail)
        setnationality(validationData?.nationality)
        setCustomerMember(validationData?.CustomerMember)
        setTravelDate(new Date(validationData.FlightBookig[0].FromUTCTime))
        SetCurrentStatus(validationData.FlightBookig[0]?.CurrentStatus)
      } else {
        toast.error(data.message, { autoClose: 2000 });
      }
    } else if (validationStatus === "failed") {
      toast.error('Request longer available.Please try again', { autoClose: 2000 });
    }
  }, [validationStatus, validationData]);

  const [Processing, setProcessing] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    let continueform = true;
    try {

      memberDetails.forEach((vl, key) => {
        let paxmsg = 'of passenger ' + (key + 1);
        if (vl.title === '') {
          toast.error('Select title ' + paxmsg, { autoClose: 2000 });
          continueform = false;
          throw new Error("Break the loop.");

        }
        if (vl.fname === '') {
          toast.error('Enter first name ' + paxmsg, { autoClose: 2000 });
          continueform = false;
          throw new Error("Break the loop.");

        }
        if (vl.lname === '') {
          toast.error('Enter last name ' + paxmsg, { autoClose: 2000 });
          continueform = false;
          throw new Error("Break the loop.");

        }
        if (vl.isdobr) {
          if (vl.dob === '') {
            toast.error('Enter Date Of Birth ' + paxmsg, { autoClose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");

          } else {
            const dobString = vl.dob;
            const PaxType = vl.PaxType;
            const maxAge = 2;
            const dobMoment = Moment(dobString, 'YYYY-MM-DD')
            const today = Moment()
            const age = today.diff(dobMoment, 'years', true);

            if (PaxType == 1) {
              if (vl.IsDocIdM) {
                if (age < 60) {
                  toast.error('Adult age should be greater than 60 year ' + paxmsg, { autoclose: 2000 });
                  continueform = false;
                  throw new Error("Break the loop.");
                }
              } else {
                if (age < 12) {
                  toast.error('Adult age should be greater than 12 year ' + paxmsg, { autoclose: 2000 });
                  continueform = false;
                  throw new Error("Break the loop.");
                }
              }
            } else if (PaxType == 2) {
              if (age < 2 || age >= 12) {
                toast.error('Child age should be 2 years or less than 12 years ' + paxmsg, { autoclose: 2000 });
                continueform = false;
                throw new Error("Break the loop.");
              }
            } else {
              if (0 <= age && age <= maxAge) {
              } else {
                toast.error("Infant category age should be less than 2 years. Use correct category to book their ticket.", { autoclose: 200 });
                continueform = false;
                throw new Error("Break the loop.");
              }
            }
          }
        }

        if (vl.IsDocIdM) {
          if (vl.docid === '') {
            toast.error('Enter Document Details ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }

        }
        if (vl.IsPassM) {
          if (vl.passnational === '') {
            toast.error('Select passport nationality ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }
          if (vl.passno === '') {
            toast.error('Enter passport number ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }
          if (vl.passisse === '') {
            toast.error('Enter Passport issue Date ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }
          if (vl.passexp === '') {
            toast.error('Enter Passport Expiry Date ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          } else {

            const passexpiry = vl.passexp;
            const passexpiryMom = Moment(passexpiry, 'DD/MM/YYYY')
            const TravelDateMom = Moment(TravelDate)

            const age = passexpiryMom.diff(TravelDateMom, 'months', true);
            if (age <= 6) {
              toast.error('Passport Expiry Date cannot be less than 6 months from last travel date ' + paxmsg, { autoclose: 2000 });
              continueform = false;
              throw new Error("Break the loop.");
            }

          }
        }


      })
    } catch (error) {
    }

    const SaveItinirary = {
      "BookingID": BookingData[0].BookingID,
      "travellerInfo": memberDetails,

    }
    if (continueform) {
      console.log(SaveItinirary);
      setProcessing(true)
      const response = await dispatch(
        UpdatePassengers({ SaveItinirary })
      ).unwrap();
      const Resultdata = response.data;
      console.log(Resultdata);

      if (Resultdata.status.success) {
        setProcessing(false)
        navigate(`/report/group-request`);
        toast.success(Resultdata.message, { autoClose: 3000 });
      } else {
        setProcessing(false)
        toast.error(Resultdata.message, { autoClose: 2000 });
        return false;
      }
    }
  }

  const handleFormChange = (event, index, date = null) => {

    let data = [...memberDetails];
    // make a copy of the specific object
    let updatedMember = { ...data[index] };
    if (typeof event === "string") {
      updatedMember[event] = date;
    } else {
      const { name, value, checked, type } = event.target;
      if (name === "checked" || name === "wchr") {
        updatedMember[name] = checked;
      } else {
        updatedMember[name] = value.toUpperCase();
      }
    }
    data[index] = updatedMember; // replace with updated copy
    setMemberDetails(data);
  };
  return (
    <>
      {isLoading && BookingData.length === 0 ? (
        <>
          <div className="bg-gray-50 min-h-screen pb-16 mt-2">

            <ItineraryLoader />
          </div>
        </>
      ) : (
        <div className="bg-gray-50 min-h-screen pb-16 ">
          <form className="mui-form" onSubmit={submit}>
            <div className="flex flex-col md:flex-row gap-6 max-w-6xl mx-auto px-4">
              <div className="flex-1 space-y-6">

                <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                  {/* Header */}
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold">
                      <Step icon={<CheckCircle className="w-5 h-5 text-white" />} title={CurrentStatus} subtitle={BookingData[0]?.BookingID} active />
                    </h3>
                  </div>

                </div>

                {BookingData.map((f, idx) => (
                  <div key={idx} className="bg-white rounded-lg shadow p-4 space-y-4">
                    <div className="flex items-center justify-between">
                      <h3 className="font-semibold">
                        {f.SoCity} → {f.DeCity} &nbsp;
                        <span className="text-sm font-normal text-gray-500">
                          on {format(new Date(f.FromUTCTime), "MMM dd, EEE, HH:mm")}
                        </span>
                      </h3>

                      {f.is_amendments === 1 ? (
                        <span className="text-1 text-red-600 flex items-center gap-1">
                          {f.CurrentStatus}
                        </span>
                      ) : (
                        <span className="text-1 text-gray-500 flex items-center gap-1">
                          {f.CurrentStatus}
                        </span>
                      )}
                      <span className="text-sm text-gray-500 flex items-center gap-1">
                        <Clock className="w-4 h-4" /> {f.Duration}
                      </span>
                    </div>

                    {f.Segments.map((SegItem, Segkey) => (
                      <div key={Segkey}>
                        <div className="flex items-start gap-4 rounded-lg bg-white">
                          {/* Airline Logo + Name */}
                          <div className="w-1/5 flex items-center gap-3">
                            <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                              <img
                                src={SegItem.filePath}
                                alt={SegItem.AirlineName}
                                className="object-contain w-full h-full"
                              />
                            </div>
                            <div>
                              <div className="font-semibold">
                                {SegItem.AirlineName} &nbsp;
                                <div className="text-gray-500">{SegItem.FlightNumber}</div>
                              </div>
                            </div>
                          </div>

                          {/* Origin */}
                          <div className="w-1/5">
                            <p className="font-bold">
                              {format(new Date(SegItem.originDepTime), "MMM dd, EEE, HH:mm")}
                            </p>
                            <p className="text-sm text-gray-600">
                              {SegItem.originCityName}, {SegItem.originCountryName}
                            </p>
                            <p className="text-sm text-gray-600">{SegItem.originAirportName}</p>
                            <p className="text-xs text-gray-400">Terminal {SegItem.DepTerminal}</p>
                          </div>

                          {/* Arrow (centered) */}
                          <div className="w-1/5 flex items-center justify-center">
                            <ArrowRight className="w-7 h-7 text-gray-400" />
                          </div>

                          {/* Destination */}
                          <div className="w-1/5">
                            <p className="font-bold">
                              {format(new Date(SegItem.destinationArrTime), "MMM dd, EEE, HH:mm")}
                            </p>
                            <p className="text-sm text-gray-600">
                              {SegItem.destinationCityName}, {SegItem.destinationCountryName}
                            </p>
                            <p className="text-sm text-gray-600">{SegItem.destinationAirportName}</p>
                            <p className="text-xs text-gray-400">Terminal {SegItem.ArrTerminal}</p>
                          </div>

                          {/* Duration & Fare Info */}
                          <div className="w-1/5">
                            <p className="font-bold">{SegItem.FlightDuration}</p>
                            <p className="text-sm text-gray-600">{f.FareLists.FareClass}</p>
                            <p className="text-sm text-red-600">{f.FareLists.fareIdentifier}</p>
                            <p className="text-xs text-gray-400">{f.FareLists.RefundableTxt}</p>
                          </div>
                        </div>



                        {/* Layover (if not last segment) */}
                        {SegItem.GroundTime > 0 && (
                          <div className="text-center my-4">
                            <span className="bg-blue-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                              Change Plane at {SegItem.LAYOVERCity}, Layover Time : {SegItem.LAYOVERDuration}
                            </span>
                          </div>
                        )}

                        <div className="text-sm text-gray-600 border-b pt-2 pb-2">
                          <p>
                            🧳 (Adult) Check-in:{f.FareLists.Checkin} Cabin: {f.FareLists.Cabin}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

                <>
                  <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    {/* Header */}
                    <div className="flex items-start justify-between">
                      <h3 className="text-lg font-semibold text-gray-800">
                        Travellers Details
                      </h3>
                      <em className="text-xs text-gray-500">
                        Name & other details should be same as in Government ID proof
                      </em>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />

                    {memberDetails.map((pitem, index) => {
                      const { minDate, maxDate } = getDobRange(pitem.pax, TravelDate);
                      const { minDate: issueMin, maxDate: issueMax } = getPassportIssueRange();
                      const { minDate: expMin, maxDate: expMax } = getPassportExpiryRange(TravelDate);
                      return (
                        <div key={index} className="mb-5">
                          {pitem.PaxCount == 1 && (
                            <div className="flex flex-wrap items-center mb-2">
                              <div className="w-full sm:w-1/2 mb-2 sm:mb-0">
                                <div className="font-semibold text-gray-700">
                                  {pitem.pax} ({pitem.AgeR})
                                </div>
                              </div>
                              <div className="w-full sm:w-1/2" />
                            </div>
                          )}

                          {/* Main checkbox row */}
                          <div className="mt-2">
                            <div className="mb-2">
                              <label
                                htmlFor={pitem.pax + '' + pitem.PaxCount}
                                className="inline-flex items-center space-x-2 cursor-pointer select-none"
                              >
                                <input
                                  type="checkbox"
                                  checked={pitem.checked}
                                  value={pitem.index}
                                  id={pitem.pax + '' + pitem.PaxCount}
                                  name="checked"
                                  readOnly
                                  index={pitem.index}
                                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-800">
                                  {pitem.title === ''
                                    ? pitem.pax + ' ' + pitem.PaxCount
                                    : pitem.title + ' ' + pitem.fname + ' ' + pitem.lname}
                                </span>
                              </label>
                            </div>
                          </div>

                          {pitem.checked && (
                            <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                              {/* Title */}
                              <div>
                                <label className="block text-sm font-medium text-gray-600">Title</label>
                                {pitem.PaxType == 1 ? (
                                  <select
                                    disabled={FormData?.reissue}
                                    className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                                    value={pitem.title}
                                    name="title"
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'salution'}
                                    index={pitem.index}
                                  >
                                    <option value="">Title</option>
                                    <option value="MR">Mr.</option>
                                    <option value="MRS">Mrs.</option>
                                    <option value="MS">Ms.</option>
                                  </select>
                                ) : (
                                  <select
                                    disabled={FormData?.reissue}
                                    className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                                    value={pitem.title}
                                    name="title"
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'salution'}
                                    index={pitem.index}
                                  >
                                    <option value="">Title</option>
                                    <option value="MISS">Miss.</option>
                                    <option value="MASTER">Master.</option>
                                  </select>
                                )}
                              </div>

                              {/* First Name (relative wrapper for dropdown) */}
                              <div className="relative w-full">
                                <label className="block text-sm font-medium text-gray-600">First Name</label>
                                <input
                                  disabled={FormData?.reissue}
                                  type="text"
                                  ref={inputRef}
                                  autoComplete="off"
                                  className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                  onKeyUp={(e) => {
                                    SearchMember(e, index, pitem.PaxType);
                                  }}
                                  onClick={(e) => {
                                    SearchMember(e, index, pitem.PaxType);
                                  }}
                                  placeholder="Enter First Name"
                                  value={pitem.fname}
                                  onChange={(event) => handleFormChange(event, index)}
                                  id={pitem.index + 'fname'}
                                  name="fname"
                                />

                                {CustomerMemberload == index + 1 && CustomerMem.length > 0 && (
                                  <div
                                    className="absolute left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg mt-1 max-h-60 overflow-y-auto z-20"

                                  >
                                    <ul className="divide-y divide-gray-100">
                                      {CustomerMem.length > 0 && (
                                        <>
                                          {CustomerMem.map((items) => (
                                            <li
                                              key={items.id}
                                              className="px-3 py-2 cursor-pointer hover"
                                              onClick={() => {
                                                setCustomerMemberload(0);
                                                handleMemberSelect(items, index);
                                              }}
                                            >
                                              <div className="text-sm font-medium text-blue-600">
                                                {items.title}. {items.name}
                                              </div>
                                              <span className="text-xs text-gray-500">
                                                {(() => {
                                                  if (items.PaxType == 1) {
                                                    return (
                                                      <>
                                                        <b>ADULT</b>
                                                      </>
                                                    );
                                                  } else if (items.PaxType == 2) {
                                                    return (
                                                      <>
                                                        <b>CHILD</b>
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <b>INFANT</b>
                                                      </>
                                                    );
                                                  }
                                                })()}{' '}
                                                - {items.passno}
                                              </span>
                                            </li>
                                          ))}
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                )}
                              </div>

                              {/* Last Name */}
                              <div>
                                <label className="block text-sm font-medium text-gray-600">Last Name</label>
                                <input
                                  disabled={FormData?.reissue}
                                  type="text"
                                  className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                  placeholder="Enter Last Name"
                                  value={pitem.lname}
                                  onChange={(event) => handleFormChange(event, index)}
                                  id={pitem.index + 'lname'}
                                  name="lname"
                                />
                              </div>

                              {/* DOB */}
                              {pitem.isdobr && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Date Of Birth <span className="text-[10px]">(dd-mm-yyyy)</span>
                                  </label>
                                  <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    defaultLevelValue={maxDate}
                                    className="w-full"
                                    value={pitem.dob}
                                    onChange={(date) => handleFormChange("dob", index, date)}
                                    rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
                                  />
                                </div>
                              )}
                              {/* IsDocIdM */}
                              {pitem.IsDocIdM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Valid ID Number <Info size={16} />
                                  </label>
                                  <input
                                    disabled={FormData?.reissue}
                                    maxLength="10"
                                    className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                    type="text"
                                    value={pitem.docid}
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'docid'}
                                    name="docid"
                                    placeholder="College ID etc.."
                                  />
                                </div>
                              )}

                              {/* Passport Nationality */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">Passport Nationality</label>
                                  <select
                                    disabled={FormData?.reissue}
                                    value={pitem.passnational}
                                    className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                                    onChange={(event) => handleFormChange(event, index)}
                                    name="passnational"
                                    id={pitem.index + 'passnational'}
                                  >
                                    {nationality.map((item, key) => (
                                      <option key={item.countryid} value={item.code}>
                                        {item.countryname} - {item.code}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              {/* Passport No */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Passport No. <span className="text-[10px]">(KF0192332C)</span>
                                  </label>
                                  <input
                                    disabled={FormData?.reissue}
                                    type="text"
                                    className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                    value={pitem.passno}
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'passno'}
                                    name="passno"
                                    placeholder="Enter passport no."
                                  />
                                </div>
                              )}

                              {/* Passport Issue */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Passport Issue <span className="text-[10px]">(dd-mm-yyyy)</span>
                                  </label>
                                  <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={issueMin}
                                    maxDate={issueMax}
                                    defaultLevelValue={issueMax} // open near today
                                    className="w-full"
                                    value={pitem.passisse}
                                    onChange={(date) => handleFormChange("passisse", index, date)}
                                    rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
                                  />
                                </div>
                              )}

                              {/* Passport Expiry */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Passport Expiry <span className="text-[10px]">(dd-mm-yyyy)</span>
                                  </label>
                                  <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={expMin}
                                    maxDate={expMax}
                                    defaultLevelValue={expMin} // open around earliest valid expiry
                                    className="w-full"
                                    value={pitem.passexp}
                                    onChange={(date) => handleFormChange("passexp", index, date)}
                                    rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
                                  />
                                </div>
                              )}

                              {/* Wheelchair */}
                              {pitem.PaxType != 3 && (
                                <div className="flex items-end">
                                  <label
                                    htmlFor={pitem.index + 'wchr'}
                                    className="inline-flex items-center space-x-2 cursor-pointer select-none"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={pitem.wchr}
                                      id={pitem.index + 'wchr'}
                                      name="wchr"
                                      onChange={(event) => handleFormChange(event, index)}
                                      className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                    <span className="text-sm text-gray-800">Wheel Chair</span>
                                  </label>
                                </div>
                              )}


                            </div>
                          )}
                        </div>
                      )
                    })}
                  </div>
                  <div className="bg-white shadow-md rounded p-3 confirm-details mt-2">
                    <div className="text-right mt-4">
                      <button disabled={Processing} type='submit' savetype='1' className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition">
                        {Processing ? (
                          <span className="flex items-center">
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Processing...
                          </span>
                        ) : (
                          <>Submit</>
                        )}
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  )
}

// Stepper component
const Step = ({ icon, title, subtitle, active }) => (
  <div className="flex items-center flex-1">
    <div
      className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${active ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-500"
        }`}
    >
      {icon}
    </div>
    <div className="ml-2">
      <p
        className={`text-mb ${active ? "font-bold text-blue-500" : "text-gray-600"
          }`}
      >
        {title}
      </p>
      <span className={`text-mb ${active ? "text-blue-500" : "text-mb text-gray-400"}`}>{subtitle}</span>
    </div>
  </div>
);
